import { postProfile, getUserFromSession, postLogout, postUserPreferences } from '../api';
export const SET_USER = 'user/SET_USER';
export const SESSION_LOADING = 'user/SESSION_LOADING';
export const SESSION_FAILED = 'user/SESSION_FAILED';
export const updateProfile = (username, avatar) => async dispatch => {
  const {
    user,
    error
  } = await postProfile(username, avatar);
  if (error || !user) {
    return {
      error: error || 'Profile unavailable'
    };
  }
  dispatch({
    type: SET_USER,
    payload: {
      user,
      error
    }
  });
  return {
    user
  };
};
export const updatePreferences = preferences => async dispatch => {
  const {
    user,
    error
  } = await postUserPreferences(preferences);
  dispatch({
    type: SET_USER,
    payload: {
      user,
      error
    }
  });
};
export const logout = () => async dispatch => {
  const {
    error
  } = await postLogout();
  dispatch({
    type: SET_USER,
    payload: {
      error,
      user: null
    }
  });
};
export const setUserFromSession = (queryString, pathname) => async (dispatch, getState) => {
  // Redux changes synchronously, so repeated clicks cannot start overlapping requests.
  if (getState().user.sessionStatus === 'loading') return;
  dispatch({
    type: SESSION_LOADING
  });
  let response;
  try {
    response = await getUserFromSession(queryString, pathname);
    if (response?.error || typeof response?.user?._id !== 'string' || !response.user._id) {
      throw new Error('Session unavailable');
    }
  } catch (_) {
    dispatch({
      type: SESSION_FAILED
    });
    return;
  }
  const {
    user,
    notifications,
    properties
  } = response;
  // Optional analytics must never prevent a valid session from loading.
  try {
    window.smartlook?.('identify', user._id, {
      name: user.username,
      email: user.email
    });
  } catch (_) {/* Continue loading. */}
  try {
    window.posthog?.identify(user._id, {
      name: user.username,
      email: user.email
    });
  } catch (_) {/* Continue loading. */}
  dispatch({
    type: SET_USER,
    payload: {
      user,
      notifications,
      properties
    }
  });
};
export const getUser = () => async dispatch => {
  const {
    user,
    notifications,
    properties
  } = await getUserFromSession();
  dispatch({
    type: SET_USER,
    payload: {
      user,
      notifications,
      properties
    }
  });
};